// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import {
  ProductListResponseDto,
  ProductReferenceDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { IDynamicBindableValue } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { Product } from 'graphql-api/gql-api-interfaces';

import { getDataLoadingProperties } from './misc';
import { getProductDataFromProductReferencesProvider } from './product-basket';
import { SingleProductDataType } from './types/single-product-data-type';

export function getListProvider(
  listIdProvider: IDynamicBindableValue,
): IDynamicBindableValue {
  const provider = {
    provider: 'HttpBodyProvider',
    property: {
      ...listIdProvider,
      transform: function (listId: string): string {
        return `/api/v2/engagement/productlist/${listId}`;
      }.toString(),
    },
  };

  return provider;
}

export function getListDataProperties(providers: {
  listId: IDynamicBindableValue;
}) {
  const getListDataProvider = getListProvider(providers.listId);

  const listDataPropertyKey = 'listData';
  const listDataLoadingProperties = getDataLoadingProperties(
    getListDataProvider,
    listDataPropertyKey,
    { jsonParse: true },
  );

  const properties = {
    ...listDataLoadingProperties,
    productReferences: {
      provider: 'self',
      property: listDataPropertyKey,
      filter: function (listData: ProductListResponseDto | undefined) {
        return Boolean(listData);
      }.toString(),
      transform: function (
        listData: ProductListResponseDto,
      ): ProductReferenceDto[] {
        return listData.productsReference ?? [];
      }.toString(),
    },
  };

  return properties;
}

export type ProductBasketProviderResultType = {
  products: Product[];
  resultCount: number;
};

export function getDataLoadingPropertiesForProductSearchFromProductReferences(providers: {
  productReferences: IDynamicBindableValue;
  listId: IDynamicBindableValue;
}) {
  const orderedProductsPropertyKey = 'orderedProducts';
  const searchResultsPropertyKey = 'searchResults';

  const properties = {
    ...getDataLoadingProperties(
      getProductDataFromProductReferencesProvider({
        productReferences: providers.productReferences,
      }),
      searchResultsPropertyKey,
    ),
    [orderedProductsPropertyKey]: {
      values: [
        {
          provider: 'self',
          property: searchResultsPropertyKey,
        },
        providers.productReferences,
      ],
      transform: function ([searchResult, productReferences]: [
        ProductBasketProviderResultType,
        ProductReferenceDto[],
      ]): Product[] {
        const products = searchResult.products;
        const productData = productReferences
          .map((pr) => {
            const product = products.find((p) => p.productId === pr.productId);
            if (!product) {
              const errorMessage = `Product with id '${pr.productId}' was not returned from search results but is in the product references of the list.`;
              console.warn(errorMessage);
            }

            return product;
          })
          .filter((p) => p !== undefined) as Product[];

        return productData;
      }.toString(),
    },
    productData: {
      values: [
        {
          provider: 'self',
          property: orderedProductsPropertyKey,
        },
        providers.listId,
      ],
      transform: function ([orderedProducts, listId]: [
        Product[],
        string,
      ]): SingleProductDataType[] {
        const productData: SingleProductDataType[] = [];
        for (const product of orderedProducts) {
          productData.push({
            media: {
              mediaType: 'IMAGE' as SingleProductDataType['media']['mediaType'],
              url: product.mainImageUrl as string,
            },
            configStrip: {
              overlayPath: [
                'cs',
                product.brandId,
                product.parentId ?? 'PARENT ID NA',
                product.productId,
              ],
            },
            product,
            correlationId: listId,
            hash: null,
            providerId: null,
            attributionToken: null,
            servingConfig: 'ProductLists',
          });
        }
        return productData;
      }.toString(),
    },
  };

  return properties;
}
